export default __webpack_public_path__ + "static/media/saturnine.fbe53220.gif";